
import React from "react";
import { useNavigate } from "react-router-dom";
import "./dashboard.css";

function DashboardPage() {
  const navigate = useNavigate();

  const handleLogout = () => {  // Clear all tokens / session data
  localStorage.removeItem("token");
  sessionStorage.clear();
    navigate("/admin/");
  };

  const forms = [
    { title: "Users", path: "/admin/users" },
    { title: "Banner Config", path: "/admin/banner-config" },
    { title: "Candidate Testimony Config", path: "/admin/candidate-testimony-config" },
    { title: "Impact Numbers", path: "/admin/impact-number" },
    { title: "Add Openigs", path: "/admin/current-openings" }
  ];

  return (
    <div className="dashboard">
      {/* Navbar */}
      <nav className="dashboard-navbar">
        <div className="logo">My Admin</div>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </nav>

      {/* Content */}
      <div className="dashboard-content">
        <h2>Admin Dashboard</h2>
        <div className="cards-container">
          {forms.map((form, idx) => (
            <div
              key={idx}
              className="dashboard-card"
              onClick={() => navigate(form.path)}
            >
              <h3>{form.title}</h3>
              <p>Configure {form.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
